<div class="flex flex-col md:flex-row items-center rounded-lg">
    <div class="md:w-2/5 w-10/12">
        <img [src]="imageSrc" class="w-full rounded-3xl" />
    </div>
    <!-- --- -->
    <div class="md:w-3/5 md:mt-0 w-10/12 mt-4">
        <div class="md:pr-12 text-center md:text-right">
            <h4 class="md:text-2xl text-base font-bold mb-6">
                از سفرت کسب درآمد کن
            </h4>
            <p class="text-black-300 mb-6 text-sm">
                می تونی با عضویت در تیم کاوشگران، تا 2 سال از هر اقامتگاه ناشناخته‌ای که پیدا و در ایران هتل آنلاین ثبت
                میکنی کسب
                درآمد داشته باشی.
            </p>
            <div class="flex md:justify-end justify-center">
                <button class="bg-blue-500 text-white py-2 px-4 rounded-lg">
                    شروع کاوشگری
                </button>

            </div>
        </div>
    </div>
</div>